export const mapType = (TYPE) => {
    switch (TYPE) {
        case 'INT':
        case 'DOUBLE':
        case 'LONG':
            return 'number';
        case 'DATETIME':
            return 'date';
        case 'BOOLEAN':
            return 'boolean';
        case 'ENUM':
            return 'enum';
        case 'TEXT':
        default:
            return 'text';
    }
};
